module.exports = __webpack_public_path__ + "static/media/sign1.e58d19fa.png";